import { Languages } from "lucide-react";
import { useI18n } from "../i18n";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  const nextLocale = locale === "zh-CN" ? "en-US" : "zh-CN";
  const label = locale === "zh-CN" ? "切换到英文" : "切换到中文";

  return (
    <button
      className={`language-switch ${className}`.trim()}
      type="button"
      onClick={() => setLocale(nextLocale)}
      aria-label={t(label)}
      title={t(label)}
    >
      <Languages aria-hidden="true" />
      <span aria-hidden="true">{locale === "zh-CN" ? "EN" : "中文"}</span>
    </button>
  );
}
